module.exports = __webpack_public_path__ + "static/media/sample_arts_cover.d833b27e.jpg";